<template>
  <div
    class="player"
    id="player"
  >
    <video
      class="video"
      v-if="mobile=='android'"
      id="video"
      width="100%"
      height="100%"
      x5-video-player-type="h5-page"
      x5-video-player-fullscreen="true"
      preload="none"
      :poster="videoPic"
      :src="videoSrc"
      controls
      contentType="video/mp4"
      :playOrPause="playOrPause"
      notSupportedMessage:='此视频暂无法播放，请稍后再试'
      @click="pauseVideo"
      @ended="onplayerEnded($event)"
      @canplay="Canplay()"
      controlsList="nodownload"
    >
    </video>
    <video
      class="video"
      v-if="mobile=='iPhone'"
      id="video"
      width="100%"
      height="100%"
      controls
      preload="none"
      show-fullscreen-btn='false'
      webkit-playsinline
      playsinline="true"
      :poster="videoPic"
      :src="videoSrc"
      :playOrPause="playOrPause"
      notSupportedMessage:='此视频暂无法播放，请稍后再试'
      @click="pauseVideo"
      @mousedown="pauseVideo"
      @touchend="pauseVideo"
      @tap="pauseVideo"
      @ended="onplayerEnded($event)"
      @canplay="Canplay()"
    >
    </video>
    <img
      src="../assets/imgs/toPlay.png"
      v-show="!playOrPause"
      class="isPause"
      @click="pauseVideo"
    >
    <div
      class="videoTit"
      v-show="!playOrPause"
    >{{videoTit}}</div>
    <div
      class="range"
      v-show='isEffective'
    >{{Math.floor(this.curTime) | sToTime}}/{{dataduration}}</div>
    <div
      class="dialogMask"
      v-show="isPhoto"
    >
      <div class="dialogBox">
        <p class="dialogTit">请拍摄学时照片</p>
        <div
          @click="openFile"
          class="takePhoto"
        >
          <input
            name="url"
            type="file"
            ref="file"
            capture="camera"
            style="display: none"
            accept="image/*"
            id="upload_input"
            @change="shangc"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { Toast, MessageBox, Indicator } from 'mint-ui'
import { Dialog } from 'vant'
import {
  getAllConfigs,
  uploadImgSize,
  summaryStatus,
  uploadJPG,
  uploadStudyTime,
  SaveVideoPlayNotesDetail
} from '../../src/api/Api'
let imgFile
let video
export default {
  components: {},
  data () {
    return {
      imgSize: '',
      vPutTime: 0, // 拍照时间间隔
      tPutTime: 0, // 上传学时时间间隔
      aPutTime: 0, // 出题验证时间间隔
      playNotesDetailId: '',
      videoObj: JSON.parse(this.$route.query.videoObj),
      totalduration: 0, // 视频总时长
      dataduration: 0,
      playOrPause: false,
      snapPT: 0, // 上传照片计时起始的时间
      snapDT: 0, // 上传学时计时起始的时间
      snapTT: 0, // 答题验证计时起始的时间
      isEffective: false, // 是否有效
      isFinish: 0, // 视频是否播放完
      isPhoto: false, // 拍照按钮是否显示,
      videoPic: '',
      videoTit: '',
      videoSrc: '',
      // videoSrc:
      //   'http://videos.gx-etrans.com/ue/ue/ueditor/jsp/upload/file/Video/1-出租汽车驾驶员从业资格管理实施细则.mp4', // 播放正常
      // // videoSrc:'http://videos.gx-etrans.com/ue/ue/ueditor/jsp/upload/file/20190929/04.mp4', //接口请求的视频 播放没画面有声
      curTime: 0,
      mobile: '',
      PlayStartTime: 0,
      isError: false, // 选错了
      isFirstToFace: false,
      year: this.$route.query.year,
      folderId: this.$route.query.folderId,
      loading: 0,
      beforeNodeCtime: ''
    }
  },
  created () {
    this.dataduration = this.videoObj.dataduration
    this.PlayStartTime = new Date().valueOf()
    this.videoTit = this.videoObj.title
    this.videoPic = window.baseapi.baseUrl + this.videoObj.image_path
    this.videoSrc = window.baseapi.baseUrl + this.videoObj.file_path
    // this.mobile = 'android'
    this.mobile =
      navigator.appVersion.indexOf('iPhoneiPhone') !== -1 ? 'iPhone' : 'android'

    this.curTime = Number(this.videoObj.play_point) * 60
  },
  mounted () {
    video = document.querySelector('#video')
    // document.addEventListener('WeixinJSBridgeReady',function(){
    //   console.log("未达到未达到未达到")
    //     video.play();
    //     this.playOrPause = true
    //   },false);
    this.snapPT = this.videoObj.play_point * 60
    this.snapDT = this.videoObj.play_point * 60
    this.snapTT = this.videoObj.play_point * 60
    console.log(this.snapPT + 'PPPPPPPPPPPPPPPPPPPP')
    this.transformVideo(video)
    // 获取上传图片大小
    uploadImgSize().then(res => {
      if (res.data.returnCode === 1) {
        this.imgSize = Number(res.data.returnDate.imageSize)
        console.log('上传图片大小：：：' + this.imgSize)
      } else {
        Toast(res.data.returnMsg)
        video.pause()
        this.$router.go(-1)
      }
    })
    // 参数配置获取
    getAllConfigs().then(res => {
      if (res.data.returnCode === 1) {
        this.vPutTime = res.data.returnDate.pzjg[0].secondMark // 拍照时间间隔
        this.tPutTime = res.data.returnDate.xssc[0].secondMark // 学时上传时间间隔
        this.aPutTime = res.data.returnDate.yzmzq[0].secondMark // 获取答题验证时间间隔
      } else {
        Toast(res.data.returnMsg)
        video.pause()
        this.$router.go(-1)
      }
    })

    // var videoPlayer = document.getElementById('video')
    var that = this
    if (
      this.videoObj.play_point !== null &&
      this.videoObj.play_point !== undefined &&
      this.videoObj.play_time !== undefined &&
      this.videoObj.play_time !== null
    ) {
      if (
        this.videoObj.played_progress === '100%' &&
        Number(this.videoObj.is_finish) === 1
      ) {
        video.pause()
        MessageBox({
          title: '提示',
          message: '学过了，再学也不计学时了!<br/>你确定还要学吗?'
          // showCancelButton: true
        }).then(action => {
          if (action === 'confirm') {
            // 确认的回调
            video.play()
            that.playOrPause = true
            console.log('再学一次')
          } else {
            return false
          }
        })
      } else {
        // 拍照去人脸识别
        // that.isPhoto = true
        // setTimeout(function(){
        that.removeConsole()
        //  },1000)
        // 是否达到计划学时
        summaryStatus({
          employeeId: sessionStorage.getItem('userId'),
          studyPlanId: this.videoObj.study_plan_id
        }).then(res => {
          console.info(res.data.code + '##$#$#$#')
          // video.play()
          // this.playOrPause = true
          // videoPlayer.play()
        })
        video.ontimeupdate = function () {
          that.onPlayerTimeupdate()
        }
        console.log(Number(that.videoObj.play_point) + 'videoObj.play_point')
        if (Number(that.videoObj.play_point) === 0) {
          video.currentTime = 0
          that.curTime = 0
        } else if (
          Number(that.videoObj.play_point) > 0 &&
          Number(that.videoObj.play_point) < Number(this.videoObj.play_time)
        ) {
          console.log('this.vedTime' + that.videoObj.play_point)
          // 断点续播
          try {
            // console.log(that.videoObj.play_point + '@@@@!#$!#@' + that.mobile)
            // if (that.mobile === 'android') {
            //   video.addEventListener('canplay', function () {
            //     video.currentTime = Number(that.videoObj.play_point) * 60
            //   })
            //   video.addEventListener('canplaythrough', function () {
            //     video.currentTime = Number(that.videoObj.play_point) * 60
            //   })
            // } else {
            //   video.addEventListener('canplay', function () {
            //     // 设置播放时间
            //     console.info('canpaly listener add')
            //     video.currentTime = Number(that.videoObj.play_point) * 60
            //     Indicator.close()
            //   })
            //   video.addEventListener('canplaythrough', function () {
            //     video.currentTime = Number(that.videoObj.play_point) * 60
            //   })
            // }
          } catch (e) {
            console.log('出错了：：：' + e)
          }
        }
      }
    }
    // video.addEventListener('timeupdate', function () {
    //   if (video.currentTime > 0) {
    //     // 当前播放的进度
    //     Indicator.close()
    //   }
    //   if (Math.floor(video.currentTime) === 1) {
    //     video.currentTime = Number(that.videoObj.play_point) * 60
    //   }
    // })
    window.myVue = this
  },
  watch: {
    loading (val) {
      if (val === 1) {
        Indicator.open({
          spinnerType: 'fading-circle'
        })
      }
    },
    totalduration (val) {
      console.log('视频总时长：' + val)
      if (val > 0) {
        Indicator.close()
      }
    }
  },
  methods: {
    openFile () {
      this.$refs.file.click()
    },
    faceImg (takePhoto) {
      var stuImg = window.baseapi.baseUrl + sessionStorage.getItem('photo')
      console.log('用户头像：：' + stuImg)
      console.log('拍摄的照片：：' + takePhoto)
      var reslut = axios
        .post('http://39.104.51.60:8061/face_compare/', {
          img_url: stuImg,
          img_data: takePhoto,
          threshold: 0.6 // 阀值是 0～1   0.5中等    0.9比较松
        })
        .then(res => {
          if (true) {
            // 是本人
            video.play()
          } else {
            // 不是本人
            Toast('检测到不是本人学习，无法继续学习')
            this.$router.go(-1)
          }
        })
    },
    removeConsole () {
      video.removeAttribute('controls')
      this.isEffective = true
      console.log(this.isEffective, 'qqwwwwwww')
    },
    transformVideo (video) {
      video.style.width = window.innerHeight + 'px'
      video.style.height = window.screen.availWidth + 'px'
      video.style.transformOrigin = 'left top'
      video.style.transform =
        'translateX(' + window.screen.availWidth + 'px) rotate(90deg)'
    },
    // listen event
    onPlayerPlay (player) {
      console.log('play')
      if (!player.isFullscreen()) {
        player.requestFullscreen()
        player.isFullscreen(true)
      }
    },
    pauseVideo () {
      // 暂停\播放
      this.transformVideo(video)
      if (this.playOrPause) {
        console.log('ififif-----pausepause')
        video.pause()
      } else {
        console.log('else-----playplayplay')
        if (parseInt(this.curTime) > 0) {
          // 设置断点播放
          video.currentTime = this.curTime
        }
        video.play()
      }
      this.loading++
      this.playOrPause = !this.playOrPause
      console.log('全屏元素')
      // eslint-disable-next-line no-undef
      // console.log($(":contains('全屏')").val())
    },
    onPlayerTimeupdate () {
      // 记录当前播放进度
      this.curTime = video.currentTime
      console.log("curTime:{}",this.curTime);
      console.log("totalduration:{}",this.totalduration);
      // console.log((this.curTime < this.totalduration) + '=================')
      if (this.totalduration > 0) {
        if (this.curTime < this.totalduration) {
          console.log(this.curTime + '进updatetime了' + this.totalduration)

          if (
            Math.floor(this.curTime) - this.snapDT >= this.tPutTime &&
            this.tPutTime !== 0
          ) {
            this.updateTime()
            this.snapDT = Math.floor(this.curTime)
          }
          if (
            Math.floor(this.curTime) % this.vPutTime === 0 &&
            this.vPutTime !== 0 &&
            Math.floor(this.curTime) > 0 &&
            Math.floor(this.curTime) > Number(this.videoObj.play_point) * 60
          ) {
            if (Math.floor(this.curTime) === Math.floor(this.beforeNodeCtime)) {
              return false
            } else {
              this.beforeNodeCtime = video.currentTime
            }
            video.pause()
            this.playOrPause = false
            this.snapPT = Math.floor(this.curTime)
            console.log('时间函数被触发')
            // 显示拍照按钮
            this.isPhoto = true
          }

          // 定时答题验证
          // if (Math.floor(video.currentTime) - this.snapTT >= 60) {
          // if (
          //   Math.floor(this.curTime) - this.snapTT >= this.aPutTime &&
          //   this.aPutTime !== 0
          // ) {
          //   video.pause()
          //   this.playOrPause = false
          //   this.snapTT = Math.floor(this.curTime)
          // this.showQcheck()
          // }
        } else {
          // 播放完了
          this.isFinish = 1
          this.updateTime()
          var type = this.platform // 继续教育0  专项学习1 道路2
          console.log('专项学习？--' + type)
          
          console.log("###"+this.videoObj);
          var isStLearn = this.videoObj.questiontypes;

          if (isStLearn==='') {
            Dialog.alert({
              title: '提示',
              message: '播放完成，返回课程列表'
            }).then(() => {
              this.$router.replace({
                path: '/vList',
                query: { year: this.year, folderId: this.folderId }
              })
            })
            return false
          }
          Dialog.alert({
            title: '提示',
            message: '播放完成，马上进行随堂测试'
          }).then(() => {
            this.$router.replace({
              path: '/cTest',
              query: {
                vId: this.videoObj.id,
                type: 0,
                year: this.year,
                folderId: this.folderId
              }
            })
          })
        }
      }
    },
    onplayerEnded (player) {
      // 播放完成清空缓存
      console.log('endendend')
      // sessionStorage.removeItem('currentTime')
    },
    // 上传有效/无效学时
    updateTime () {
      let pdTime = Number(this.videoObj.play_point)
      let pro =
        Math.floor((Number(this.curTime) / Number(this.totalduration)) * 100) +
        '%'
      console.log(
        pdTime + 'pdTimepdTimepdTimepdTimepdTimepdTimepdTimepdTime' + pro
      )
      let pPoint = Number(this.curTime) / 60
      console.log('pPointpPoint' + pPoint)
      uploadStudyTime({
        StartTime: new Date().valueOf(),
        PlayProgress: pro,
        StuId: sessionStorage.getItem('userId'),
        VideoId: this.videoObj.id,
        StudyPlanId: this.videoObj.study_plan_id,
        CompanyId: this.videoObj.company_id, //sessionStorage.getItem('companyId'),
        IsFinish: this.isFinish,
        IsSource: false,
        NowTime: Math.floor(pPoint)
      }).then(res => {
        if (res.data.returnCode === 1) {
          console.log('上传成功')
        } else {
          console.log('上传失败')
        }
      })
    },
    shangc () {
      console.log('@#@#@#@#@#@@')
      let _this = this
      let file = document.getElementById('upload_input').files[0]
      // 判断图片类型
      if (
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/JPG'
      ) {
        var isJPG = true
      } else {
        isJPG = false
      }
      // 判断图片大小
      const isLt2M = file.size / 1024 / 1024 < this.imgSize
      // const isLt2M = file.size / 1024 / 1024 < 25
      if (!isJPG) {
        _this.$message.error('上传图片只能是 JPG/PNG/JPEG 格式!')
      }
      if (!isLt2M) {
        _this.$message.error('上传图片过大，请降低照片质量重试!')
      }
      // 创建一个HTML5的FileReader对象
      var reader = new FileReader()
      // 创建一个img对象
      var img = new Image()
      // let filename = options.filename
      if (file) {
        reader.readAsDataURL(file)
      }
      if (isJPG && isLt2M) {
        reader.onload = e => {
          // let base64Str = reader.result.split(',')[1]
          img.src = e.target.result
          imgFile = e.target.result
          // base64地址图片加载完毕后执行
          img.onload = function () {
            // 缩放图片需要的canvas（也可以在DOM中直接定义canvas标签，这样就能把压缩完的图片不转base64也能直接显示出来）
            var canvas = document.createElement('canvas')
            var context = canvas.getContext('2d')
            // 图片原始尺寸
            var originWidth = this.width
            var originHeight = this.height
            // 最大尺寸限制，可通过设置宽高来实现图片压缩程度
            var maxWidth = 300
            var maxHeight = 300
            // 目标尺寸
            var targetWidth = originWidth
            var targetHeight = originHeight
            // 图片尺寸超过最大尺寸的限制
            if (originWidth > maxWidth || originHeight > maxHeight) {
              if (originWidth / originHeight > maxWidth / maxHeight) {
                // 更改宽度，按照宽度限定尺寸
                targetWidth = maxWidth
                targetHeight = Math.round(
                  maxWidth * (originHeight / originWidth)
                )
              } else {
                targetHeight = maxHeight
                targetWidth = Math.round(
                  maxHeight * (originWidth / originHeight)
                )
              }
            }
            // 对图片进行缩放
            canvas.width = targetWidth
            canvas.height = targetHeight
            // 清除画布
            context.clearRect(0, 0, targetWidth, targetHeight)
            // 图片压缩
            context.drawImage(img, 0, 0, targetWidth, targetHeight)
            /* 第一个参数是创建的img对象；第二三个参数是左上角坐标，后面两个是画布区域宽高 */
            // 压缩后的base64文件
            imgFile = canvas.toDataURL('image/jpeg', 0.92)
            document.getElementsByClassName(
              'takePhoto'
            )[0].style.backgroundImage = 'url(' + imgFile + ')'
            if (_this.isFirstToFace) {
              // 刚进来 先人脸识别
              _this.faceImg(imgFile)
            } else {
              _this.isFirstToFace = false
              uploadJPG({
                employeeId: sessionStorage.getItem('userId'),
                videoPlayNotesId: _this.videoObj.nodes_id,
                uploadTime: _this.dateFormat(),
                studyPlanId: _this.videoObj.study_plan_id,
                coursewareId: _this.videoObj.id,
                imageDate: imgFile
              }).then(res => {
                if (res.data.code === 200) {
                  document.getElementById('upload_input').value = ''
                  Toast('学习照片上传成功，待审核......')
                  _this.isPhoto = false
                  video.play()
                  _this.playOrPause = true
                } else {
                  Toast('学习照片上传失败，请重试')
                  _this.isPhoto = false
                }
                document.getElementsByClassName(
                  'takePhoto'
                )[0].style.background =
                  'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAABoCAYAAAB2dPv0AAAIDElEQVR4Xu2dd3PUPBCHFWpCgDRK6KR9/+8TekvoLZBGIMxzg2cOx86d2km2fjtzkz+wVXafdy3trvRO7e7uHhuJNJBIA1MCMJHm1e1AAwJQICTVgABMqn51LgDFQFINCMCk6lfnAlAMJNWAAEyqfnUuAMVAUg0IwKTqV+cCUAwk1YAATKp+dS4AxUBSDQjApOpX5wJQDCTVgABMqn51LgDFQFINCMCk6lfnAlAMJNWAAEyqfnUuAMVAUg0IwKTqV+cCUAwk1YAATKp+dS4AGxj48+eP2d3dNQcHB96EXLx40Vy6dMmcOXPGu60+NiAAa1Y9PDw0L1++NPwNJRcuXDD37983/JX8rwEBOKSP4+Nj8+bNG/P9+/fgnFy9etXcuXPHTE1NBW+7yw0KwCHr7ezsmFevXkWz571798yVK1eitd/FhgXgP6ux7nvy5In59etXNDueP3/erK6umrNnz0bro2sNC8B/Fnv37p359OlTdPstLS2ZmzdvRu+nKx0IQGPM3t6eef78uWENGFtYAz58+NDMzMzE7qoT7fcKQMIm3759sw6f7O/vR/301kngUzw9PW0FCOGcubk5w98+SS8AxHN9+PBh8AmdhBdLBQDek0/49evXe7Ob7gWAHz9+NO/fv0/FxcT7vXHjhrl27drE+43RYecBZNf6+PHjXnu+uuHxhOvr64ZPedel8wB++fLFbG9vd90O1uO/deuWWVhYsH4vtxc6D+CkwieV4cjpklIjlocnYs35+/fvQeqOWOKkpC/hHAE4BjEUE5DBmJ2dHcAHeMMpNSDkB4Q/f/4cpPII7cQUARhTuxZtx/SA5G9Z7NuGTICRkBC7csJCMUQAxtCqQ5sxAAS45eXlQRmVjwAiMUbWqPwNKQIwpDY92goNIAt7UmUh6/dYGzJONkyhRACG0qRnOyEBJL6GYccpmarWffX1YNt0eJ5Pcqh4pQD0BCfU66EAJLvAeq8NPgCiSvrHjx+DDcbR0dFg14unPHfu3CC3e/ny5cFn+7Q2CJqTtfEVAeirwUDvhwCQHOvt27cbwQE8drWAM06JPrlaQGYD0wQi7W1tbXlvTgRgIIB8m/EF8LQaPbwcGwgKVW2FsA3BYrxjXYgbPnv2zKvsXwDaWiTS874AtlUpk+LjbMg4Xq9tanhDzoI0pcx8q68FYCSgbJv1AZD12oMHD058KvFQ1Af6wFfNAwip/6tXQfMpfvHixWBd6SIC0EVrEd7xAbDN+7FG+/r1a7DRzs/PD9aYdfHxggIwmHn8GnIFkLUZFSX1eB8eCe8XWvCC9cA2u2gqeVhr2ooAtNVYpOddAWzzSqz7CLWEFkI0rAfr4uptBWBoCzm25wogn0QgHJaYtYVtNXx86oHQVgSgrcYiPe8K4Nra2onzFRQOcDA9lnAwnZjjsJAjfvr0qXWXAtBaZXFecAEQb7SxsXEiRkeajIBzLCFATbpvWFj/bW5uWncpAK1VFucFFwDZeABgPTSC94tVPsXs8X54wWEh5PPo0SPrYlYBGIcn61ZdAAQ8AKzvgF+/fh3lXphqUk0AshMGQEC0EQFoo62Iz7oA2OYBSbuFLJmqT5tSL9JzdQ/IJ9j2OKkAjAiVTdMuANI+HrCeIvv8+bN5+/atTfdWz1Lkuri4+N877LzxgLYiAG01Ful5VwCJyRGbGxbXHem4U+Nionp5v2s2RACOq/XIz7kCSP0fv2HhM0hIJEQOuD5tcsIAWC/Rct15C8DIYI3bvCuAFJCSHqsDEesz3PT5BXjKslzOiwjAcQmJ/JwrgAyrKRjNrhQoQnpBvN/KysqJXTd9cCehiwhAF61FeMcHwKZdKUOkIIFSKdudadP0TruOzWfXLQAjwOTSpA+AhGNYlzVdHh4qLdeUfmOeHGJnvel6m4IAdKElwjs+ADKc0y4P5ywIhQIukAA3BQ+0X5cQl6ELwAgwuTTpCyB9NlXGVGPBUxEbtCnRIrzD2eK2yyRdK2CG9SMAXWiJ8E4IAPFWlOa3XZuLx+IoJuAAYlMBKQWu3B3DupJ22o5m0g7rSxevKgAjAOTbZAgAGQMAEZwedQ8MMJK94FedCyajwm/UgXbCLRS8ulRA1/UkD+hLTqD3QwHIcChS4JyI750wTVNjZ83/g8S26KBNTQIwEEC+zYQEkLHgxajZI2c7yqONM3Y8JsFtMh4hwjpVnwJwHO1P4JnQAFZD5lMMiKzrXECsrvJgfC6ZjlGqE4CjNDShf48FYDV8NhScHeGmg+pW1LapVbelUmDAhiXmJZUCcEKAjeomNoBV/3hBvCI/AtdsWqoretlUEK7B0/EL+anVGnAUAYn/fVIAJp7mie7lATOxSKkANh1wysQkVsPo/CXlpMs4y1Ga3L17tzHN1zU9dB5An+stumasarwEvSklC3mNcCpddB5AFEd6jCDvJBb/qQw1vBkiWF4/TpB6XK799wJAJs//n4P6OnajfRV235yqIzbZF+kNgBiEzzGxNyqN++QNCfdQWUNMsg+f3eH/eHoFYF+8QknzEIAlWTvDuQrADI1S0pAEYEnWznCuAjBDo5Q0JAFYkrUznKsAzNAoJQ1JAJZk7QznKgAzNEpJQxKAJVk7w7kKwAyNUtKQBGBJ1s5wrgIwQ6OUNCQBWJK1M5yrAMzQKCUNSQCWZO0M5yoAMzRKSUMSgCVZO8O5CsAMjVLSkARgSdbOcK4CMEOjlDQkAViStTOcqwDM0CglDUkAlmTtDOc6leGYNKSCNPAXPyIpO6hohuQAAAAASUVORK5CYII=) no-repeat 50%'
              })
            }
          }
        }
      }
    },
    Canplay () {
      // 获取视频总时长
      this.totalduration = Math.floor(video.duration)
      console.log(typeof this.totalduration + '总时长' + video.duration)
    },
    dateFormat () {
      var date = new Date()
      var year = date.getFullYear()
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var seconds =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      // 拼接
      return (
        year +
        '-' +
        month +
        '-' +
        day +
        ' ' +
        hours +
        ':' +
        minutes +
        ':' +
        seconds
      )
    },
    saveVideoPlayNotesDetail () {
      let playedTime =
        Math.floor(this.curTime) / 60 - this.videoObj.play_point > 1
          ? Math.floor(Math.floor(this.curTime) / 60) - this.videoObj.play_point
          : 0
      // 视频播放记录保存
      SaveVideoPlayNotesDetail({
        PlayStartTime: this.PlayStartTime,
        PlayEndTime: new Date().valueOf(),
        StudyMonth: this.videoObj.study_month,
        // playTime: , // 退出播放时的实际时间
        StuId: sessionStorage.getItem('userId'),
        VideoId: this.videoObj.id, // 资料ID
        ValidCount: playedTime, // 有效学时
        StudyPlanId: this.videoObj.study_plan_id
      }).then(res => {
        console.log('视频播放记录保存的接口返回结果:::' + res.data.returnCode)
      })
    }
  },
  destroyed () {
    console.log('!!!!销毁了！！！！')
    console.log(video.currentTime)
    try {
      video.pause()
      this.saveVideoPlayNotesDetail()
    } catch (e) {
      console.log('销毁出错了：：：' + e)
    }
  },
  computed: {
    ...mapGetters(['platform'])
  }
}
</script>
<style scoped>
html,
body,
#app,
.player {
  width: 100%;
  height: 100%;
}
.mint-toast {
  -webkit-transform: translate(-50%, -50%) rotate(90deg) !important;
  transform: translate(-50%, -50%) rotate(90deg) !important;
}
.dialogBox {
  transform: rotate(90deg);
}
.videoTit {
  background: rgba(0, 0, 0, 0.4);
  height: 0.38rem;
  line-height: 0.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  padding: 5px;
  position: fixed;
  width: 96%;
  bottom: 0;
  left: 0;
  top: 0;
  color: #fff;
  margin: auto;
  transform: rotate(90deg);
  right: 0;
  margin-right: -3rem;
}

#upload {
  display: none;
}
.player {
  object-fit: fill;
}
.box {
  width: 1.15rem;
  height: 1.15rem;
  border-radius: 1.15rem;
  display: inline-block;
  position: relative;
  margin-left: 20px;
  vertical-align: middle;
}
.takePhoto {
  width: 2.5rem;
  height: 2rem;
  margin: 0 auto;
  background: url('../assets/imgs/takePhoto.png') no-repeat center;
  background-size: contain;
}
.addImg {
  width: 1.15rem;
  height: 1.15rem;
  border-radius: 1.15rem;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  cursor: pointer;
  border: none;
}
.preview,
.preBlock {
  position: absolute;
  display: block;
  width: 1.15rem;
  height: 1.15rem;
  border-radius: 1.15rem;
  left: 0;
  top: 0;
  border: none;
}
.video-player .vjs_video_3-dimensions.vjs-fluid {
  padding-top: 0;
}
#video_content {
  position: relative;
  width: 100%;
  height: 100%;
}
.uImg {
  width: 2.8rem;
  height: 2.2rem;
  margin: 0 auto;
}
.isPause {
  width: 0.8rem;
  height: 0.8rem;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  transform: rotate(90deg);
}
.ansDialog {
  width: 8rem;
  height: 5.8rem;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background: #fff;
  border-radius: 0.06rem;
  transform: rotate(90deg);
  text-align: center;
  padding: 0.45rem 0.8rem;
  box-sizing: border-box;
}
.dailogT {
  font-size: 0.32rem;
}
.ansDia-que {
  margin-top: 0.68rem;
  color: #000;
  font-size: 1rem;
}
.errorMsg {
  color: red;
  font-size: 0.24rem;
  margin: 0.2rem auto 0.6rem;
  height: 0.32rem;
}
.ansItems {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.ansItems li {
  color: #91b0dc;
  border: 1px solid #91b0dc;
  font-size: 0.8rem;
  width: 1.1rem;
  height: 1rem;
  text-align: center;
  line-height: 1rem;
  display: inline-block;
}
.ansItems li.activeItem {
  color: #fff;
  background: #91b0dc;
}
.ansDiv {
  border-bottom: 2px solid #b5b5b4;
  height: 0.4rem;
  display: inline-block;
  width: 0.8rem;
}
</style>



// WEBPACK FOOTER //
// src/views/vedioDemo.vue